import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "backing-information" }
const _hoisted_2 = { class: "_mb-2 gfu-project-banner__field-label" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backing_information_list = _resolveComponent("backing-information-list")
  const _component_backing_information_modal = _resolveComponent("backing-information-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.ProjectHome.ProjectStoryBackingInformationSectionLabel), 1 /* TEXT */),
    _createVNode(_component_backing_information_list, {
      items: $options.mappedBackingInformationItems,
      onSelect: $options.onSelect
    }, null, 8 /* PROPS */, ["items", "onSelect"]),
    ($data.isModalOpen)
      ? (_openBlock(), _createBlock(_component_backing_information_modal, _mergeProps({ key: 0 }, $options.currentModalProps, {
          "current-key": $data.selectedKey,
          "is-stretch-pay-enabled": $props.isStretchPayEnabled,
          "is-stable-pledge-enabled": $props.isStablePledgeEnabled,
          "is-crowdfunding-risks-enabled": $props.isCrowdfundingRisksEnabled,
          onClose: $options.onClose,
          onSelect: $options.onSelect
        }), null, 16 /* FULL_PROPS */, ["current-key", "is-stretch-pay-enabled", "is-stable-pledge-enabled", "is-crowdfunding-risks-enabled", "onClose", "onSelect"]))
      : _createCommentVNode("v-if", true)
  ]))
}